export default "__VITE_ASSET__BctiwduN__"